export const employmentIssues = [
    {
      value: 'B',
      label: 'Bullying',
    },
    {
      value: 'RR',
      label: 'Redundancy',
    },
    {
      value: 'W',
      label: 'Whistleblowing',
    },
    {
      value: 'S',
      label: 'Sickness',
    },
    {
      value: 'Sn',
      label: 'Suspension',
    },
    {
      value: 'Dy',
      label: 'Disciplinary',
    },
    {
      value: 'H',
      label: 'Unsafe workplace',
    },
    {
      value: 'P',
      label: 'Performance',
    },
    {
      value: 'TWE',
      label: 'Toxic work environment',
    },
    {
      value: 'EW',
      label: 'Excessive workload',
    },
    {
      value: 'M',
      label: 'Money owed',
    },
    {
      value: 'F',
      label: 'No contract',
    },
    {
      value: 'OBT',
      label: 'Other',
    },
  ];
